import { $themeConfig } from '@themeConfig'

const initUnread = () => {
  const data = {
    withdrawal: 0,
    deposit: 0,
    chat: 0,
    order: 0
  }
  const storageData = {}
  try {
    const localUnread = JSON.parse(localStorage.getItem("unread"));
    Object.assign(storageData, localUnread);
  } catch (error) {
    //
  }
  return {
    ...data,
    ...storageData
  }
}


export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
    unread: initUnread(),
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },

    UPDATE_UNREAD(state, payload) {
      state.unread = {
        ...state.unread,
        ...payload
      }
      localStorage.setItem("unread", JSON.stringify(state.unread));
    },
  },
  actions: {
    updateUnread({ commit }, payload) {
      commit("UPDATE_UNREAD", payload);
    },

    increaseUnread({ state, commit }, key) {
      const count = state.unread[key] || 0;
      commit("UPDATE_UNREAD", { [key]: count + 1});
    }
  },
}
